export default __webpack_public_path__ + "static/media/regulatory--triple-lanes-turn-left-center-lane--g1.e4a2f108.png";